var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app dashboard",attrs:{"id":"inspire"}},[_c('app-drawer',{staticClass:"app--drawer",attrs:{"expanded":_vm.showDrawer}}),_c('app-toolbar',{staticClass:"app--toolbar",on:{"side-icon-click":_vm.handleDrawerVisiable}}),_c('v-content',[_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1)]),_c('app-fab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }